import React from "react"
import styled from "styled-components"
import Language from "./language"
import { useIntl, Link } from "gatsby-plugin-intl"

const MenuContainer = styled.nav`
  ul {
    display: flex;
    li {
      list-style: none;
      margin-right: 2rem;
      font-weight: bold;
      a {
        text-decoration: none;
        color: white;
      }
      &:last-child {
        margin-right: 0 !important;
      }
    }
  }
`

const Menu = () => {
  const intl = useIntl()

  return (
    <MenuContainer>
      <ul style={{ display: "flex" }} className="navbar">
        <li>
          <Link activeClassName="active" to="/">
            {intl.formatMessage({ id: "MENU.HOME" })}
          </Link>
        </li>
        <li>
          <Link activeClassName="active" to="/about">
            {intl.formatMessage({ id: "MENU.ABOUT" })}
          </Link>
        </li>
        <li>
          <Link activeClassName="active" to="/alumni">
            {intl.formatMessage({ id: "MENU.ALUMNI" })}
          </Link>
        </li>
        <li>
          <Link activeClassName="active" to="/contact">
            {intl.formatMessage({ id: "MENU.CONTACT" })}
          </Link>
        </li>
        <li>
          <Language />
        </li>
      </ul>
    </MenuContainer>
  )
}

export default Menu
